import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { fetchMerklOpportunityUrl, type MerklTarget } from '@/helpers/reward/fetchMerklOpportunityUrl';
const buildQueryKey = (target: MerklTarget | null | undefined) => {
  if (!target) return ['merkl', 'disabled'] as const;
  return target.kind === 'market' ? ['merkl', 'market', target.chainId, target.marketId, target.loanTokenAddress] as const : ['merkl', 'vault', target.chainId, target.identifier] as const;
};
export const useMerklOpportunityUrl = target => {
  const $ = _c(8);
  let t0;
  if ($[0] !== target) {
    t0 = buildQueryKey(target);
    $[0] = target;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== target) {
    t1 = () => fetchMerklOpportunityUrl(target);
    $[2] = target;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = !!target;
  let t3;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      staleTime: 300000,
      gcTime: 600000,
      retry: 1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    data
  } = useQuery(t3);
  return data ?? null;
};